import React,{ useState, useMemo } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ATMList = ({ data, callbackSelect }) => {
  const [expanded, setExpanded] = React.useState("0");
  const [query, setQuery] = React.useState();
  const [locData, setLocData] = React.useState();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  // Function to get filtered list
  function getSearchList() {
    setLocData(data?.filter((s) => s.PageTitle.toLowerCase().includes(query) || s.Address.toLowerCase().includes(query))); 
  }

  var searchList = useMemo(getSearchList, [query]);

  return (
    <div id="customScroll" className="branchesListContainer">
      <div className="branchSearchContainer">
        <label htmlFor="atm-search">Search</label>
        <input
          id="atm-search"
          type="search"
          placeholder="Search Branch by Location..."
          name="search"
          aria-label="Search ATM by location"
          onChange={(e) => setQuery(e.target.value.toLowerCase())}
        />
      </div>

      <div className="branchesAccordianContainer" tabIndex={0} role="region" aria-label="ATM list">
      {query?.length > 0 ? (
            <>
              {locData?.length > 0 ? (
              <>
              {locData.map((i, index) => (
                <Accordion 
                key={index}
                onClick={() =>
                    callbackSelect({ id: i.id, lat: i.latitude, lng: i.longitude })
                }
                expanded={expanded === `${index}`} 
                onChange={handleChange(`${index}`)}
                sx={{
                  '& .MuiPaper-root-MuiAccordion-root.Mui-expanded':{
                    margin: '0px',
                  },
                  '& .MuiPaper-root-MuiAccordion-root': {
                    border: '2px solid red',
                    borderRadius: '10px',
                  },
                  '& .MuiAccordionSummary-root': {
                      height: '20px',
                      backgroundColor: '#fff',
                      color: '#003399',
                      borderRadius: '10px',
                    },
                    '& .MuiAccordionSummary-root.Mui-expanded': {
                        minHeight: '30px',
                        '& .MuiTypography-root':{
                          color: '#dd1134'
                        },
                        '& .MuiSvgIcon-root': {
                          color: '#dd1134',
                      },
                      },
                }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`atm-search-panel-content-${index}`}
                  id={`atm-search-panel-header-${index}`}
                  sx={{
                    '& .MuiSvgIcon-root': {
                        fontSize: '20px',
                        color: '#003399',
                    },
                }}
                >
                  <Typography sx={{
                    fontSize: '14px',
                    fontWeight: '500',
                  }}>{i.PageTitle}</Typography>
                </AccordionSummary>

                  <AccordionDetails
                    id={`atm-search-panel-content-${index}`}
                  >
                    <div className='branch-accordion-details-container' tabIndex={0} role="region" aria-label={i.PageTitle}>
                      <p tabIndex={0}>Address: {i.Address}</p>
                    </div>
                  </AccordionDetails>
                </Accordion>
                ))}
              </>
            ) : (
              <h3 tabIndex={0}>Sorry, No Results Found</h3>
            )}
            </>
          ) : (
            <>
            {data?.map((i, index) => (
              <Accordion 
              key={index}
              onClick={() =>
                callbackSelect({ id: i.id, lat: i.latitude, lng: i.longitude })
              }
              expanded={expanded === `${index}`} 
              onChange={handleChange(`${index}`)}
              sx={{
                '& .MuiPaper-root-MuiAccordion-root.Mui-expanded':{
                  margin: '0px',
                },
                '& .MuiPaper-root-MuiAccordion-root': {
                  border: '2px solid red',
                  borderRadius: '10px',
                },
                '& .MuiAccordionSummary-root': {
                    height: '20px',
                    backgroundColor: '#fff',
                    color: '#003399',
                    borderRadius: '10px',
                  },
                  '& .MuiAccordionSummary-root.Mui-expanded': {
                      minHeight: '30px',
                      '& .MuiTypography-root':{
                        color: '#dd1134'
                      },
                      '& .MuiSvgIcon-root': {
                        color: '#dd1134',
                    },
                    },
              }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`atm-panel-content-${index}`}
                id={`atm-panel-header-${index}`}
                sx={{
                  '& .MuiSvgIcon-root': {
                      fontSize: '20px',
                      color: '#003399',
                  },
              }}
              >
                <Typography sx={{
                  fontSize: '14px',
                  fontWeight: '500',
                }}>{i.PageTitle}</Typography>
              </AccordionSummary>

                <AccordionDetails
                  id={`atm-panel-content-${index}`}
                >
                  <div className='branch-accordion-details-container' tabIndex={0} role="region" aria-label={i.PageTitle}>
                    <p tabIndex={0}>Address: {i.Address}</p>
                  </div>
                </AccordionDetails>
              </Accordion>
            ))} 
            </>
          )}
      </div>
    </div>
  );
};

export default ATMList;
